import { inject, Injectable } from '@angular/core';
import {
    browserTracingIntegration,
    captureConsoleIntegration,
    contextLinesIntegration,
    httpClientIntegration,
    init,
    replayIntegration,
} from '@sentry/angular';
import { LogService } from 'shared/core/data-access/log';
import { SENTRY_CONFIG } from '../../providers/sentry-config/sentry-config.token';

@Injectable({
    providedIn: 'root',
})
export class SentryService {
    #config = inject(SENTRY_CONFIG);
    #logService = inject(LogService);

    init = () => {
        if (this.#config.dsn) {
            this.#logService.debug('[Sentry] init');
            init({
                dsn: this.#config.dsn,
                release: `${this.#config.appName}@${this.#config.version}`,
                environment: this.#config.environment,
                integrations: [
                    browserTracingIntegration(),
                    replayIntegration(),
                    httpClientIntegration(),
                    contextLinesIntegration(),
                    captureConsoleIntegration({
                        levels: ['warn', 'error', 'assert'],
                    }),
                ],
                tracesSampleRate: 1.0,
                tracePropagationTargets: [],
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
            });
        }
    };
}
